import React from "react";
import { AutocompleteInput, ReferenceInput, SelectInput } from "react-admin";
import { bookmakersConfig } from "../bookmakers";
import SubmitFilters from "../components/filters/SubmitFilters";

const Filters = (props) => {
	return (
		<SubmitFilters {...props}>
			<ReferenceInput
				source="contest_id"
				fullWidth
				reference="contests"
				resettable
			>
				<SelectInput optionText="title" />
			</ReferenceInput>
			<ReferenceInput
				source="bookmaker_id"
				reference="bookmakers"
				filter={{ status: "active" }}
				fullWidth
				{...bookmakersConfig.reference}
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
		</SubmitFilters>
	);
};
export default Filters;
